import classNames from "classnames";
import * as React from "react";
import { VirtListRowProps } from "../BaseList";
import { groupedListsPaddingClasses } from "./listGroupsHelpers";

export interface ListWithGroupsRowType {
    group?: boolean;
}

export const ListWithGroupsRowWrapper: React.FC<VirtListRowProps<ListWithGroupsRowType>> = props => {
    const className = classNames(groupedListsPaddingClasses(props));

    return <div className={className}>{props.children}</div>;
};
